// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { Text } from "@fluentui/react";
import { Broom24Regular } from "@fluentui/react-icons";

import styles from "./ClearChatButton.module.css";

interface Props {
    className?: string;
    onClick: () => void;
    disabled?: boolean;
}

export const ClearChatButton = ({ className, disabled, onClick }: Props) => {

    const handleClick = () => {
        if (!disabled) {
            onClick();
        }
    };

    return (
        <div
            id="clearChatButton"
            className={`${styles.container} ${className ?? ""} ${disabled && styles.disabled}`}
            onClick={handleClick}>
            <Broom24Regular />
            <Text>{"Clear chat"}</Text>
        </div>
    );
};
